import actions from '@/store/modules/reviews/actions.js'

export default {
  actions,
}
